
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/Scrollbar.html",
      function () {
        return require("private-next-pages/Interaction/Scrollbar.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/Scrollbar.html"])
      });
    }
  